/**
 * Cleans up an HTML string by replacing all &nbsp; entities with spaces.
 * @param {string} htmlString - The raw HTML string to sanitize.
 * @returns {string} - The cleaned HTML string.
 */
export function cleanHtmlString(htmlString) {
  if (typeof htmlString !== "string") return "";
  return htmlString.replace(/&nbsp;/g, " ");
}